import { Icons, SVGIcon } from '../../../../components/atoms/SVG';

const images = ['jpg', 'jpeg', 'pjpeg', 'gif', 'png', 'bmp', 'svg', 'tiff', 'tif', 'dwg', 'dxf', 'plt', 'wmf'];
const word = ['doc', 'docx', 'docm', 'dot', 'dotx'];
const excel = ['xls', 'xlsx', 'xlsb', 'xlsm', 'xlt'];
const powerpoint = ['ppt', 'pptx', 'ppsx', 'pot', 'potx', 'pptm'];
const audio = ['mp3', 'wav'];
const video = ['avi', 'mov', 'mpg', 'mp4', 'wmv', 'ogg'];
const zip = ['zip', 'gzip', '7zip'];
const vcard = ['vcf'];
const ical = ['ics'];
const text = ['txt'];
const csv = ['csv'];
const pdf = ['pdf'];

const isIncludedIn = (type: string[], extension: string): string | null => {
  if (type.includes(extension.toLowerCase())) {
    return extension;
  }
  return null;
};
const iconAndClass = (iconFileName: SVGIcon, className = '') => ({ className, iconFileName });

export const getFileIcon = (fileExtension: string | null) => {
  if (!fileExtension) {
    return iconAndClass(Icons.FILE_DEFAULT);
  }

  const includedIn = (type: string[]) => isIncludedIn(type, fileExtension);

  switch (fileExtension) {
    case includedIn(images):
      return iconAndClass(Icons.FILE_PICTURE);
    case includedIn(word):
      return iconAndClass(Icons.FILE_WORD, 'download--doc');
    case includedIn(excel):
      return iconAndClass(Icons.FILE_EXCEL, 'download--xls');
    case includedIn(pdf):
      return iconAndClass(Icons.FILE_PDF, 'download--pdf');
    case includedIn(powerpoint):
      return iconAndClass(Icons.FILE_POWER_POINT, 'download--ppt');
    case includedIn(zip):
      return iconAndClass(Icons.FILE_ZIP);
    case includedIn(audio):
      return iconAndClass(Icons.FILE_SOUND);
    case includedIn(video):
      return iconAndClass(Icons.FILE_VIDEO);
    case includedIn(vcard):
      return iconAndClass(Icons.FILE_VCARD);
    case includedIn(ical):
      return iconAndClass(Icons.FILE_ICAL);
    case includedIn(text):
    case includedIn(csv):
      return iconAndClass(Icons.FILE_TEXT);
    default:
      return iconAndClass(Icons.FILE_DEFAULT);
  }
};
